// extracted by mini-css-extract-plugin
module.exports = {"achievementCard":"style_achievementCard__2cbfQ","link":"style_link__33yIa"};